import React from "react";
import { UiAuthContainer } from "../../_uiComponents/common/custom/header/UiTopNavElements";

import AboutusForm from "./forms/AboutusForm";

export default function AboutusSection(props) {
    return (
        <>
            <UiAuthContainer>
                <div className="sb-auth-top-wr sb-auth-top-wr-top-tlc sb-auth-about-section">
                    <div className="sb-about-us-top-section">

                    
                    <h4>Your Loyalty Deserves to Be Rewarded!</h4>
                    <p>Join the Renault Trade Loyalty Club today and start earning points with every parts purchase from your Renault and Dacia Trade Retailer. </p>
                   <h5>What's in it for you? </h5>
                   </div>

                   <div className="sb-about-us-bottom-section">
                    <p>Your points unlock a world of choice! Shop your favourite brands like JDSports, JohnLewis, PaulSmith, and Screwfix, or grab a bite with Just Eat. Dream bigger with incredible experiences from Virgin Experience Days, Disneyland Paris, and so much more!</p>
                    
                    <AboutusForm/>
                   </div>
                     
                    
                </div>
            </UiAuthContainer>
        </>
    );
}
